import variables from '../variables';

const secondary = {
  main: variables.themeColors.secondary,
  dark: variables.themeColors.secondary,
  light: variables.themeColors.secondaryLight,
};

export default secondary;
